<section class="no-selection-report">
  <table
    [class]="'table styled-table blueAndWhite'">
    <thead>
      <tr>
        <th>
          @if (showProgressReportsHelp) {
            <zbp-button-component 
              [iconName]="helpMenuIconName"
              theme="icon"
              (clickHandler)="openHelp()"
              ariaLabel="Information about reports"
            />
          }
          <span class="sr-only">Reports table</span>
        </th>
      </tr>
    </thead>
    <tr>
      <td class="no-report-row" colspan="6">
        <ng-container>
          <div class="cell-content">
            <i class="fa fa-circle-info info-circle"></i>
            <div class="no-report-text">{{noDataMessage}}</div>
          </div>
        </ng-container>
      </td>
    </tr>
  </table>
</section>
